<template><div v-show="options_loaded && passed_filter && options_filter" class="stylesoption">
    <div class="form-group" :class="[!valid_selection ? 'has-error' : '']" :data-designer-component-id="component_id">
        <label :for="'question--' + component_id">{{ title }}</label>
        <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
        </select>
        <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
            <option>Loading Options...</option>
        </select>
    </div>
</div></template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Choose your Letterbox Position';
                }
            },
            component_id: {
                default(){
                    return 'hardware_letterbox_position';
                }
            },
            hardwareLetterbox: {
                required: true
            },
            slab: {
                required: true
            },
            sidePanels: {
                required: true
            },
            frameId: {
                required: true
            },
            frameMaterial: {
                required: true
            },
            doorRange: {
                default() {
                    return 0;
                }
            }
        },
        computed: {
            filtered_option_list(){
                if (Array.isArray(this.option_list)) {
                    return this.option_list.filter((key) => {
                        return key.value !== null;
                    });
                } else {
                    return [];
                }
            },
            passed_filter(){
                return this.variable_ready(this.slab, this.hardwareLetterbox, this.sidePanels, this.frameId, this.frameMaterial);
            },
            options_filter(){
                return this.filtered_option_list.length > 1;
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-position?category=7&slab=' + this.slab
                    + '&hardware_id=' + this.hardwareLetterbox
                    + '&left=' + this.left_panel
                    + '&right=' + this.right_panel
                    + '&left_composite_id=' + this.left_composite_id
                    + '&right_composite_id=' + this.right_composite_id
                    + '&frame_id=' + this.frameId
                    + '&frame_material=' + this.frameMaterial
                    + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.hardwareLetterbox + '_' + this.left_panel + '_' + this.right_panel + '_' + this.left_composite_id + '_' + this.right_composite_id + '_' + this.frameId + '_' + this.frameMaterial + '_' + this.doorRange;
            },
            left_panel(){
                if (this.sidePanels.left === null) {
                    return 1;
                }
                return this.sidePanels.left;
            },
            right_panel(){
                if (this.sidePanels.right === null) {
                    return 1;
                }
                return this.sidePanels.right;
            },
            left_composite_id(){
                if (this.sidePanels.left_composite_id === null) {
                    return 31;
                }
                return this.sidePanels.left_composite_id;
            },
            right_composite_id(){
                if (this.sidePanels.right_composite_id === null) {
                    return 31;
                }
                return this.sidePanels.right_composite_id;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
